import type { State } from "metabase-types/store";

export const currentOpenModal = (state: State) => state.modal;
